import { EvEbitdaValues, EvEbitdaResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateEvEbitda(values: EvEbitdaValues, t?: ToolsTranslations['evEbitda']): EvEbitdaResult {
  const { enterpriseValue, ebitda } = values;

  if (enterpriseValue <= 0) {
    return { evEbitda: null, isValid: false, message: t?.invalid.enterpriseValue ?? 'Enterprise value måste vara större än 0' };
  }
  if (ebitda <= 0) {
    return { evEbitda: null, isValid: false, message: t?.invalid.ebitda ?? 'EBITDA måste vara större än 0' };
  }

  const evEbitda = Math.round((enterpriseValue / ebitda) * 100) / 100; // PREC(...,2) - rounds to 2 decimal places
  
  if (!isFinite(evEbitda)) {
    return { evEbitda: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }
  
  return { evEbitda, isValid: true };
}
